<template>
	<v-dialog 
		v-model="open"
		fullscreen
		persistent
		transition="dialog-bottom-transition"
		style="overflow-x: hidden"
		scrollable>
		<v-card class="background-1 rounded-0" v-if="open">
			<v-card-title class="pa-3">
				<p class="pl-2 pl-xl-3">Genera Pagamenti {{ $trans(infoFieldsset.modelDef) }}</p>
				<v-spacer></v-spacer>
				<v-btn icon @click.native.stop="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
			</v-card-title>
			<v-divider></v-divider>
			
			<v-card-text style="overflow-x: hidden" class="pa-0">

				<v-container class="px-6" fluid>
					<v-row class="mx-0">
						<v-col cols="12" class="display-flex px-1 pt-6 pb-0">
							<strong>Impostazioni</strong>
						</v-col>
					</v-row>
					<v-card class="round-card background-2 pa-4 px-0 mt-6 pt-12">
						<fields-generator
							v-if="loaded"
							:fieldsset.sync="infoFieldsset"
							:model.sync="filters"
							ref="fieldsgenerator"
						></fields-generator>
						<v-row class="ma-0 px-6 pb-6">
							<small>
								<div class="payment-methods-info">
									<p><strong>Con RIBA</strong> saranno mostrate solo le scadenze con Metodo di Pagamento:</p>
									<ul>
										<li>RIBA (MP12)</li>
									</ul>
									<br>
									<p><strong>Con SDD</strong> saranno mostrate solo le scadenze con Metodo di Pagamento:</p>
									<ul>
										<li>RID (MP09)</li>
										<li>RID utente (MP10)</li>
										<li>RID veloce (MP11)</li>
										<li>SEPA Direct Debit (MP19)</li>
										<li>SEPA Direct Debit CORE (MP20)</li>
										<li>SEPA Direct Debit B2B (MP21)</li>
									</ul>
								</div>
							</small>

						</v-row>
					</v-card>
				</v-container>

				<v-container class="px-6" fluid>
					<v-row class="mx-0">
						<v-col cols="12" class="display-flex px-1 pt-6 pb-0">
							<strong>Scadenze Selezionate</strong>
							<span class="grey--text pr-4">&nbsp;({{ deadlines.length }})</span>

							<div class="display-flex">
								<strong>Dati di Pagamento Corretti&nbsp;</strong>
								<v-icon color="success" class="">mdi-cash</v-icon>
								<span class="grey--text pr-4">&nbsp;({{ countPaymentInfoCorrect }})</span>
							</div>
							<div class="display-flex">
								<strong>Dati di Pagamento Mancanti&nbsp;</strong>
								<v-icon color="error" class="">mdi-cash</v-icon>
								<span class="grey--text pr-4">&nbsp;({{ countPaymentInfoErrors }})</span>
							</div>
						</v-col>
					</v-row>
				</v-container>

				<v-container class="px-6" fluid>
					<v-card class="round-card background-2 pa-4">
						<v-row class="mx-0 py-2">
							<v-col class="pa-0" cols="12" sm="12" md="6" lg="3" v-for="(deadline, key, i) in deadlines" :key="i">
								<v-list two-line dense class="background-2 w100p py-0">
									<v-list-item @click="openNewTab(deadline.id)" @click.middle="openNewTab(deadline.id)">
										<v-list-item-action>
											<v-icon :color="checkPaymentInfo(deadline.payment_data) ? 'success' : 'error'">mdi-bank</v-icon>
										</v-list-item-action>
										<v-list-item-content>
											<v-list-item-title style="font-size: 12px !important">{{ deadline.name }} ({{ deadline.business_name }})</v-list-item-title>
											<v-list-item-subtitle>{{ deadline.payment_data }}</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>
								</v-list>
							</v-col>
							<v-col class="pa-0" cols="12" sm="12" md="6" lg="3" v-if="deadlines.length == 0">
								<v-list two-line dense class="background-2 w100p py-0">
									<v-list-item>
										<v-list-item-content>
											<v-list-item-title style="font-size: 12px !important">Nessuna scadenza selezionata</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</v-list>
							</v-col>
						</v-row>
					</v-card>
					<small class="pl-2">Se i dati bancari non sono presenti la distinta non verrà creata.</small>
				</v-container>		
	

			</v-card-text>

			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="info" @click.native="$emit('close')">Annulla</v-btn>
				<v-btn text color="primary" @click.native="validateFields()" :loading="sending">Procedi</v-btn>
			</v-card-actions>
		</v-card>

		<confirm-dialog
		    :confirmModel="confirmGeneratePayments"
		    mainTitle="Sei sicuro di generare questi pagamenti?"
		    secondTitle="Una volta premuto 'Genera' sarà avviata la generazione del file delle distinte di pagamento."
		    @update:confirmModel="confirmGeneratePayments = false"
		    :atConfirm="generatePaymentsRemittence"
			:confirm="{color: 'info', label: 'genera'}"
		></confirm-dialog>
	</v-dialog>
</template>

<script>

	export default {
		name: 'generate-payments',
		props: {
			params: Object,
			selected: Array,
			selectedIds: Array,
			modelDef: String,
			open: Boolean,
			button: Object,
		},
		
		data() {
			return {
				deadlines: [],
				infoFieldsset: [],
				model: {},
				filters: {},
				ids: [],
				sending: false,
				loading: false,
				loaded: false,
				confirmGeneratePayments: false,
			}
		},

		watch: {
			open: {
				handler(newValue, oldValue) {
					if(newValue) {
						this.getInfo()
					}
				}
			},
			
			filters: {
				handler() {
					this.getData()
				},
				deep: true
			},
			
		},
		
		methods: {

			getData() {
				this.axios.post('generate-payments-remittance-data/', {ids: this.selectedIds, model: this.button.model, filters: this.filters}).then(response => {
					// get body data
					this.$set(this, 'deadlines', response.data.data)

				}, response => {
					// error callback
				})				
			},
			
			getInfo() {
				this.axios.get('generate-payments-remittance-info/').then(response => {
					// get body data
					this.infoFieldsset = response.data.fields					
					
					_.forEach(this.infoFieldsset.fields, (value, key) => {
						if(value.type === 'checkbox') {
							this.$set(this.filters, value.key, '')
						}
						if(value.default) {
							this.$set(this.filters, value.key, value.default)
						}
					})

					_.forEach(this.defaultInput, (value, key) => {
						this.$set(this.filters, key, value)
					})

					this.loaded = true
					this.getData()

				}, response => {
					// error callback
				})				
			},

			openNewTab(id) {
				const url = this.$router.resolve({ name: 'companydeadlines-show', params: { id: parseInt(id), ...this.params }}).href
				window.open(url, '_blank')
			},
			
			checkPaymentInfo(payment_info) {
				payment_info = (payment_info || '').toLowerCase()
				if(payment_info === undefined || payment_info == null || payment_info !== 'completi') {
					return false
				} else {
					return true
				}
			},

			generatePaymentsRemittence() {
				this.sending = true

				let dataObject = {
					filters: this.filters,
					ids: this.deadlines.map((deadline) => {
						return deadline.id
					})
				}

				this.axios.post('generate-payments-remittance', dataObject).then(response => {
					// get body data
					this.sending = false

					this.$store.commit('setSnackbar', {timeout: 6000, text: response.data.message, value: true, color: response.data.status})

					this.$emit('close')
				}, response => {
					// error callback
					this.sending = false
				})
			},

			validateFields() {
				this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
					if (!result) {
						return false
					} else {
						this.confirmGeneratePayments = true
					}

				}).catch(() => {

				})
			},
		},

		computed: {
			countPaymentInfoErrors() {
				if(this.deadlines) {
					let count = 0
					_.forEach(this.deadlines, (deadline) => {
						const paymentStatus = (deadline.payment_data || '').toLowerCase()
						if(paymentStatus !== 'completi') {
							count++
						}
					})
					return count
				}
				return 0
			},

			countPaymentInfoCorrect() {
				return this.deadlines.length - this.countPaymentInfoErrors
			}
		},

	}
</script>
